module.exports = __webpack_public_path__ + "static/media/placeholder-user.e22e36b0.png";